export default __webpack_public_path__ + "static/1-6100306a2eebfbcbdeea4d02bfba79a2.jpeg";